import styled from 'styled-components/macro';
import { rgba } from 'polished';
import { COLORS, Z_INDEX } from 'styleguide';

import StatesContainer from './StatesContainer';

const StatesDropdown = styled.div`
  position: absolute;
  top: -10px;
  left: 35px;
  display: none;
  width: 265px;
  padding: 15px 25px;
  box-shadow: 0 4px 16px 0 ${rgba(COLORS.line, 0.6)};
  border-radius: 4px;
  background-color: ${COLORS.line};
  z-index: ${Z_INDEX.pop_up};

  &::after {
    content: '';
    position: absolute;
    top: 15px;
    left: -8px;
    display: block;
    width: 16px;
    height: 16px;
    transform: rotate(45deg);
    background-color: ${COLORS.line};
  }

  &:hover,
  ${/* sc-sel */StatesContainer}:hover + & {
    display: block;
  }
`;

export default StatesDropdown;
